// 260521: 간판ON 이용약관 v1 (적용일 2026-05-20). 운영팀이 docx 원문 그대로 박음.
// 출처: 카카오톡 받은 파일 '간판ON 이용약관_20260520.docx'
export const TERMS_KANPANON_V1 = `“간판ON” 이용약관
본 약관은 (주)점프(이하 '회사')가 제공하는 간판ON 서비스 및 관련 제반 서비스의 이용과 관련하여 필요한 사항을 규정합니다. 회원약관은 다음과 같은 내용을 담고 있습니다.
제1조 목적
본 이용약관(이하 ‘약관’이라 함)은 (주)점프(이하 ‘회사)가 제공하는 간판ON 서비스(이하 '서비스')와 이용고객(이하 ‘회원’)간에 가입조건 및 이용에 관한 제반사항과 기타 필요한 사항을 구체적으로 규정함을 목적으로 합니다.
제2조 정의
이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
 (1) ‘서비스’라 함은 구현되는 단말기(PC, 모니터, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 ‘이용자’가 이용할 수 있는 간판ON 비즈니스 네트워킹 관련 제반 서비스를 의미합니다.
 (2) ‘회원’이라 함은 ‘회사’에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 서비스에 자유롭게 접속하여 정보를 지속적으로 제공받을 수 있거나 사이트가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.
 (3) ‘비회원’이라 함은 ‘회원’으로 가입하지 않고 ‘회사’가 제공하는 서비스를 이용하는 자를 말합니다.
 (4) ‘이용자’라 함은 회사의 서비스를 이용하는 자를 말하며, 회원과 비회원을 모두 포함합니다.
 (5) '사장님' 또는 '사업자 회원'이라 함은 사업자등록번호 인증을 거쳐 비즈니스를 등록한 회원을 말합니다.
(6) '비즈니스'라 함은 사장님이 회사의 서비스에 등록한 사업체 정보를 말합니다.
(7) '간판'이라 함은 비즈니스에 연결되어 메인 캐러셀 및 검색 결과에 노출되는 사장님의 홍보 단위를 말합니다.
(8) '배터리'라 함은 간판을 정해진 시간 동안 노출되도록 하는 회사 내부의 시간 단위 자원을 말합니다.
(9) '앰버서더'라 함은 회사가 직접 인증·위촉한 사업자 회원으로, 별도의 노출 정책이 적용되는 회원을 말합니다.
(10) ‘게시물’이라 함은 ‘이용자’가 서비스를 이용함에 있어 서비스 상에 게시한 부호 • 문자 • 음성 • 음향 • 화상 • 동영상 • 로고 간판• 사진 • 비즈니스 사진 • 소개글 • 태그 • 이벤트 • 구인 공고 등의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.
제3조 약관의 게시와 개정
1. ‘회사’는 이 약관의 내용을 ‘이용자’가 알 수 있도록 ‘서비스’ 화면에 게시합니다.
2. ‘회사’는 ‘약관의 규제에 관한 법률’ ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 ‘정보통신망법’) 등 관련 법률에 위배되지 않는 범위내에서 이 약관을 개정할 수 있습니다.
3. ‘회사’가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 제1항의 방식에 따라 그 개정약관의 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, ‘이용자’에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 ‘회사’는 제1항의 방식에 따라 개정약관 내용을 ‘이용자’가 알기 쉽도록 표시합니다.
4. ‘회원’은 변경된 약관에 동의하지 않을 권리가 있으며, 변경된 약관에 동의하지 않을 경우에는 서비스 이용을 중단하고 탈퇴를 요청할 수 있습니다. 다만, ‘이용자’가 제3항의 방법 등으로 ‘회사’가 별도 고지한 약관 개정 공지 기간 내에 ‘회사’에 개정 약관에 동의하지 않는다는 명시적인 의사표시를 하지 않는 경우 변경된 약관에 동의한 것으로 간주합니다.
제4조 관련법령과의 관계
이 약관에서 정하지 않은 사항은 전기통신사업법, 전자거래기본법, 정보통신망법, 전자상거래 등에서의 소비자보호에 관한 법률, 개인정보보호법 등 관련 법령의 규정과 일반적인 상관례에 따릅니다.
제5조 이용계약의 체결
1. 이용계약은 ‘회원’이 되고자 하는 자(이하 ‘가입신청자’)가 약관의 내용에 대하여 동의를 한 다음 회원가입 신청을 하고 ‘회사’가 이러한 신청에 대하여 승인함으로써 체결됩니다.
2. ‘회사’는 ‘가입신청자’의 신청에 대하여 ‘서비스’ 이용을 승낙함을 원칙으로 하며, 성립시기는 ‘회사’가 가입완료를 신청절차 상에 표시한 시점으로 합니다.
3. 제1항에 따른 신청에 있어 ‘회사’는 ‘가입신청자’에게 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.
4. 회원가입은 휴대폰 본인인증을 통해 이루어지며, 카카오·네이버·Google 등 외부 사업자가 제공하는 소셜 로그인을 이용한 가입도 가능합니다.
5. 사장님 회원으로 등록하기 위해서는 사업자등록번호 인증이 추가로 요구됩니다. 국내 사업자는 국세청 자동 검증을 통해 즉시 처리되며, 해외 사업자는 회사의 관리자가 검토·승인합니다.
6. ‘회사’는 서비스관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
제6조 회원정보의 변경
‘회원’은 회원가입 시 등록한 사항에 관하여 변경이 발생한 경우, 지체없이 ‘회사’에 대하여 회원정보 수정 등의 방법으로 그 변경사항을 알려야 하며 변경사항을 알리지 않아 발생한 불이익에 대하여 ‘회사’는 책임지지 않습니다.
제7조 이용계약의 종료 및 재가입 제한
1. ‘회원’의 해지
 (1) ‘회원’은 언제든지 ‘회사’에게 해지의사를 통지함으로써 이용계약을 해지할 수 있습니다.
 (2) ‘회사’는 제1호에 따른 ‘회원’의 해지요청에 대해 특별한 사정이 없는 한 이를 즉시 처리합니다.
 (3) ‘회원’이 계약을 해지하여 계약이 종료되는 경우  ‘회원’이 작성한 게시물 등은 삭제, 페기됩니다. 단, 다른 회원과 공동으로 작성한 게시물(예: 회원이 받은 좋아요 기록 등)은 게시물의 동일성을 해치지 않는 범위 내에서 익명화 처리되어 보관될 수 있습니다.
(4) 어뷰징 방지를 위하여 해지 후 30일 이내에는 동일한 인증정보(휴대폰 번호 등)로 재가입이 제한될 수 있습니다.
2. ‘회사’의 해지
 (1) ‘회사’는 다음과 같은 사유가 있는 경우 이용계약을 해지할 수 있습니다.
회원이 회사나 다른 회원 기타 타인의 권리나 명예를 침해하는 행위를 한 경우
회원이 회사의 정책에 위배되는 행위를 하거나 이 약관에서 규정하고 있는 이용의무를 위반한 경우
제13조에서 정한 광고 게재 제한 업종에 해당함이 확인된 경우
 (2) 이용계약 해지는 ‘회사’ 는 ‘회원’에게 전자우편, 앱 내 알림, 전화, 문자, 기타의 방법 등으로 통지하거나 ‘회사’ 게시판에 게시함으로써 통지를 갈음합니다. 다만, ‘회사’는 해당 ‘회원’에게 해지사유에 대한 의견진술의 기회를 부여할 수 있습니다.
(3) 위 사항에 따라 ‘회사’의 해지로 인해 이용계약이 종료될 경우 ‘회원’의 모든 게시물들은 삭제, 폐기 됩니다. 단, 형, 민사상의 법률 및 증거보존, 기타 법률에 따라 그 게시물들을 보존하여야 하는 경우 ‘회사’가 임의적으로 정한 별도의 장소에서 보관할 수 있습니다.
제8조 개인정보보호의 의무
‘회사’는 ‘정보통신망’등 관계법령이 정하는 바에 따라 ‘회원’의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 ‘회사’의 개인정보취급방침이 적용됩니다. 다만, ‘회사’의 ‘서비스’ 이외의 링크된 사이트에서는 ‘회사’의 개인정보취급방침이 적용되지 않습니다.
제9조 회원의 계정 관리의무
1. ‘회원’은 자신의 로그인 정보(소셜 로그인 토큰 포함)를 제3자에게 양도하거나 이용하게 해서는 안됩니다.
2. ‘회원’은 자신의 로그인 정보를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 즉시 ‘회사’에 통보하고 ‘회사’의 조치가 있는 경우에는 그에 따라야 합니다.
3. ‘회원’이 제2항에 따른 통지를 하지 않거나 ‘회사’의 조치에 응하지 아니하여 발생하는 모든 불이익에 대한 책임은 ‘회원’에게 있습니다.
제10조 회사의 의무
1. ‘회사’는 관련법과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 ‘서비스’를 제공하기 위하여 최선을 다하여 노력합니다.
2. ‘회사’는 서비스에 장애가 생길 경우 지체없이 이를 수리 복구하여야 합니다. 다만, 천재지변, 비상사태 또는 그 밖에 부득이한 경우에는 그 서비스를 중단하거나 중지할 수 있습니다. 
3. ‘회사’는 서비스 이용과 관련하여 ‘회원’으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다.
4. ‘회사’는 사업의 폐업 또는 휴업 예정일 30일전까지 특별한 시정이 없는 한 ‘회원’에게 그 사실을 통보하여야 합니다. 이 경우 ‘회사’는 ‘회원’이 등록한 전자우편, 앱 내 알림, 전화 기타의 방법을 통해 통지하거나 ‘회사’ 게시판에 게시함으로써 통지를 갈음합니다.
제11조 회원 및 이용자의 의무
1. ‘이용자’는 관계법령 및 이 약관의 규정, ‘회사’의 정책, 이용안내 등 ‘회사’가 통지 또는 공지하는 사항을 준수하여야 하며, 기타 ‘회사’업무에 방해되는 행위를 하여서는 안됩니다.
2. ‘이용자’는 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 안됩니다.
(1) 서비스 신청 또는 변경 시 허위 내용의 등록(사업자등록번호, 비즈니스명, 주소, 카테고리, 연락처 등 허위 기재)
(2) 타인의 사업자등록번호·신분증을 도용하거나 명의를 빌려 가입·등록하는 행위
(3) 회사에 게시된 정보의 허가받지 않은 변경
(4) 다른 이용자의 정보를 수집·저장·공개 및 부정하게 사용하는 행위
(5) 회사 또는 제3자의 저작권 등 지적재산권에 대한 침해
(6) 회사 및 제3자의 명예를 손상시키거나 업무를 방해하는 행위
(7) 외설·폭력적인 내용, 공서양속에 반하는 정보를 서비스에 공개·게시하는 행위
(8) 자동 접속 프로그램(매크로, 봇 등)을 사용하여 회사의 서버에 부하를 일으키거나 정상적인 서비스를 방해하는 행위
(9) 좋아요·추천·명함 등 회사가 제공하는 기능을 정상적인 용법과 다른 방식으로 사용하여 배터리·노출 등 회사의 자원을 부당하게 취득하는 행위
(10) 기타 불법적이거나 부당한 행위
(11) 자동 접속 프로그램 등을 사용하는 등 정상적인 용법과 다른 방법으로 서비스를 이용하여 회사의 서버에 부하를 일으켜 회사의 정상적인 서비스를 방해하는 행위
3. ‘이용자’는 반드시 본인이 직접 서비스를 이용해야 하며, 이용계약상 지위를 타인에게 양도, 증여하거나 본인 이외의 타인이 서비스를 이용하여 발생하는 문제에 대한 책임은 이용자 본인에게 있습니다.
제12조 게시물 관리 및 저작권
1. ‘이용자’가 작성한 게시물에 대하여 그 저작권은 해당 ‘이용자’에게 있으며, 이 게시물들에 대한 모든 책임은 이를 게시한 ‘이용자’에게 귀속됩니다.  
2. ‘회사’는 ‘이용자’가 게시하거나 등록하는 게시물의 내용이 다음 각 호에 해당한다고 판단되는 경우 해당 게시물을 사전 통지 없이 삭제 또는 임시조치 할 수 있습니다.
 (1) 다른 회원 또는 제3자를 비방하거나 명예를 손상시키는 경우
 (2) 공공질서 및 미풍양속에 위반되는 내용일 경우
 (3) 범죄적 행위에 결부된다고 인정되는 경우
 (4) ‘회사’의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
 (5) 해당 서비스와 관련 없는 내용인 경우
 (6) ‘회사’의 서비스 약관, 운영정책 등의 내용을 위반할 우려가 있거나 위반행위를 한 경우
3. ‘이용자’의 ‘게시물’이 정보통신망법 및 저작권법 등 관련법에 위반되는 내용을 포함하는 경우 권리자는 관련법이 정한 절차에 따라 해당 ‘게시물’의 게시중단 및 삭제 등을 요청할 수 있으며, ‘회사’는 관련법에 따라 조치를 취하여야 합니다.
4. 본 조에 따른 세부절차는 정보통신망법 및 저작권법이 규정한 범위 내에서 회사가 정한 게시중단요청 서비스에 따릅니다. 
5. ‘서비스(앱·웹 사이트,디자인,UI,로고,아이콘,텍스트 등’에 대한 저작권 및 지적재산권은 ‘회사’에 귀속됩니다. 단, ‘이용자’의 게시물 및 제휴계약에 따라 제공된 저작물 등은 제외합니다. 
제13조 광고 게재 제한 업종
1. 다음 각 호에 해당하는 업종 또는 해당 업종과 관련된 게시물은 사전 고지 없이 노출이 중지되거나 등록이 거부될 수 있습니다.
(1) 도박·사행성 관련업
(2) 성인용 게임장, 성인오락실
(3) 성인용품 판매업
(4) 불건전 오락기구 관련업
(5) 다단계 판매업
(6) 흥신소, 신용조사 및 추심대행업
(7) 유흥주점업
(8) 기타 관련 법령 및 회사의 운영정책에 위배되는 업종
2. ‘회사’는 제1항에 해당하는 등록을 발견한 경우 즉시 노출을 중지하고 ‘회원’에게 통보하며, 회원이 이를 회복하기 위해 사용한 배터리·결제 등에 대해서는 회사의 정책에 따라 환불 또는 보전 조치를 검토할 수 있습니다.
제14조 간판 노출 정책
1. 사장님 회원은 비즈니스 등록 후 간판을 켜기(ON) 토글하여 메인 캐러셀(추천 간판)에 노출시킬 수 있습니다.
2. 간판이 메인 캐러셀에 노출되기 위해서는 다음 조건을 모두 충족하여야 합니다.
(1) 사장님이 사업자등록번호 인증을 완료할 것
(2) 간판이 켜진(ON) 상태일 것
(3) 배터리가 충전되어 있고, 사장님이 설정한 노출 시간대(요일·시간 슬롯)에 해당할 것
3. 신규 등록된 사장님(최근 30일 이내)은 별도의 '신규 등록 ZONE'에 노출될 수 있습니다.
4. 사장님이 협업 제안 수용 옵션을 켠 경우 '협업 ZONE'에 노출되어 다른 사장님으로부터 제휴·협업 제안을 받을 수 있습니다.
5. 회사는 노출 알고리즘(거리, 인증 여부, 최근 등록일, 랜덤 롤링 등)을 운영상 필요에 따라 변경할 수 있으며, 변경 시 사전 또는 사후 공지합니다.
제15조 배터리 시스템 및 충전 경로
1. 간판 노출은 배터리 잔량을 기반으로 이루어집니다. 배터리는 4시간 단위 슬롯으로 구성되며, 사장님은 자신의 노출 시간대(요일·시작 시각)를 직접 설정할 수 있습니다.
2. 배터리는 다음과 같은 경로로 충전할 수 있습니다. 각 충전 경로별 시간·조건은 회사의 운영정책에 따라 변경될 수 있으며, 변경 시 사전 또는 사후 공지합니다.
(1) 체험 배터리: 회원 가입 후 1회에 한하여 24시간의 체험 배터리를 지급받을 수 있습니다.
(2) 좋아요 보상: 회원이 다른 비즈니스에 좋아요를 1일 6회 이상 누른 경우 1일 1회에 한하여 4시간의 보상 배터리를 지급받을 수 있습니다.
(3) 마케팅 정보 수신 동의 보상: 신규 마케팅 정보 수신 동의에 대하여 1일 1회 4시간의 보상 배터리를 지급받을 수 있습니다.
(4) 추천(친구 초대) 보상: 추천한 회원이 가입 후 일정 조건을 충족하면 추천인에게 168시간의 슈퍼 배터리가 지급될 수 있습니다. 추천 보상은 어뷰징 방지를 위해 일정 기간 락(lock)이 설정될 수 있습니다.
(5) 인앱결제: Google Play 및 Apple App Store의 인앱결제를 통하여 배터리를 구매할 수 있습니다.
3. 회사는 좋아요·추천 등 보상 충전 경로에서 어뷰징이 확인된 경우 해당 보상을 회수하고 추가 조치를 취할 수 있습니다.
4. 회원이 탈퇴하는 경우 미사용 보상 배터리(체험, 좋아요, 마케팅 동의, 추천)는 회수되며, 인앱결제로 구매한 배터리의 환불은 제18조에 따릅니다.
제16조 앰버서더
1. 회사는 일정 기준에 부합하는 사장님 회원을 앰버서더로 위촉할 수 있습니다.
2. 앰버서더는 24시간 노출(ALWAYS ON)이 가능하며, 위촉 기간 동안 별도의 배터리 차감 없이 간판이 노출됩니다.
3. 앰버서더 위촉 및 해제 기준·기간은 회사가 별도로 정하며, 회원은 언제든지 '수동 설정으로 전환'을 통해 앰버서더 적용을 해제할 수 있습니다. 단, 일단 수동 설정으로 전환한 경우 앰버서더 자격은 자동으로 복원되지 않으며, 회사가 재위촉 절차를 거쳐야 합니다.
4. 앰버서더 회원도 이 약관 및 회사의 운영정책을 동일하게 준수하여야 하며, 위반 시 위촉이 해제되고 일반 회원과 동일한 노출 정책이 적용됩니다.
제17조 서비스의 변경
1. ‘회사’는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 ‘서비스’를 변경할 수 있습니다.
2. ‘회사’는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 ‘이용자’에게 별도의 보상을 하지 않습니다.
제18조 서비스의 이용시간 및 중단
1. ‘서비스’의 이용은 ‘회사’의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간을 원칙으로 합니다. 다만, 정기점검 등의 필요로 ‘회사’가 정한 날이나 시간은 제외됩니다. 
2. ‘회사’는 ‘서비스’의 원활한 수행을 위하여 필요한 기간을 정하여 사전에 공지하고 ‘서비스’를 중지할 수 있습니다. 단, 불가피하게 긴급한 조치를 필요로 하는 경우 사후에 통지할 수도 있습니다.
3. ‘회사’는 컴퓨터 등 정보통신설비의 보수점검  • 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 ‘서비스’의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
제16조 손해배상 및 책임제한
1. ‘회사’와 ‘이용자’는 서비스 이용과 관련하여 고의 또는 과실로 상대방에게 손해를 끼친 경우에는 이를 배상하여야 합니다. 단, 회사는 무료로 제공하는 서비스의 이용과 관련하여 개인정보보호 정책에서 정하는 내용에 위반하지 않는 한 어떠한 손해도 책임을 지지 않습니다.
2. ‘회사’는 천재지변, 전쟁, 해킹 등 불가항력적이 사유 또는 ‘이용자’의 귀책사유로 인해  ‘서비스’를 제공할 수 없는 경우에는 ‘서비스’ 이용의 장애에 대하여 책임을 지지 않습니다.
3. ‘회사’는 ‘이용자’가 ‘서비스’에 게시한 게시물의 정보, 자료, 이미지 등 내용에 관하여는 책임을 지지 않습니다.
4. ‘회사’가 이용자 전원을 대상으로 서비스에 관한 내용의 변경 등을 고지하기 위해 사전에 홈페이지 또는 서비스 초기화면 등에 그러한 내용들을 고지하여 게시한 경우, 고지된 서비스 내용에 관하여 인지하지 못한 이용자에 대하여 ‘회사’는 책임을 지지 않습니다.
제17조 인앱결제 및 환불
1. 회원은 Google Play 및 Apple App Store의 인앱결제를 통하여 배터리 등 회사가 정한 디지털콘텐츠를 구매할 수 있습니다.
2. 결제는 각 스토어 사업자(Google, Apple)의 결제 시스템을 통하여 이루어지며, 결제 관련 분쟁은 우선적으로 각 스토어 사업자의 정책 및 절차에 따라 처리됩니다.
3. 인앱결제로 구매한 디지털콘텐츠의 환불은 다음에 따릅니다.
(1) 「전자상거래 등에서의 소비자보호에 관한 법률」에 따라 미사용 디지털콘텐츠는 결제일로부터 7일 이내 청약 철회가 가능합니다. 단, 일부라도 사용한 콘텐츠는 청약 철회가 제한될 수 있습니다.
(2) 청약 철회 및 환불 요청은 각 스토어 사업자의 환불 절차에 따라 진행하며, 회사는 회원의 요청에 따라 결제 내역 확인 등 협조를 제공합니다.
(3) 회사 또는 회원의 귀책 사유에 따른 환불은 관련 법령 및 회사가 별도로 정한 환불 정책에 따릅니다.
4. 회원이 본 약관 또는 관련 법령을 위반하여 이용계약이 해지되는 경우 미사용 결제 잔여분에 대한 환불 여부는 회사의 정책에 따라 결정됩니다.
제18조 알림 및 마케팅 정보 수신
1. 회사는 서비스 이용에 필요한 정보(이용 안내, 인증, 결제, 시스템 점검 등 '서비스 알림')를 회원에게 발송할 수 있으며, 이는 의무적 알림으로 회원이 별도로 거부할 수 없습니다.
2. 광고성 정보 및 마케팅성 알림은 「정보통신망법」 제50조에 따라 회원의 사전 동의를 받은 경우에만 발송되며, 회원은 언제든지 수신을 거부할 수 있습니다.
3. 회원은 앱 내 알림 설정에서 채널(푸시·이메일·문자), 카테고리별 수신 여부를 직접 설정할 수 있으며, 야간 시간대(예: 22:00 ~ 08:00)에는 방해금지 시간이 적용되어 서비스 알림을 제외한 알림 발송이 제한될 수 있습니다.
4. 회사는 알림 발송 시 정보통신망법 제50조 제4항에 따라 광고 표시, 발신자 정보, 수신거부 방법을 명시합니다.
제19조 기부 기능에 대한 규정
1. ‘회사’는 기부자와 수혜자가 서로 연결될 수 있도록 소개·연결 서비스만을 제공합니다.
2. ‘회사’는 기부금품을 직접 수령·보관·분배하지 않습니다.
3. 기부의 실행, 기부금품의 전달, 영수증 발급 및 세무 처리는 전적으로 기부자와 수혜자의 책임 하에 이루어집니다.
제20조 기부자 및 수혜자의 책임
1. 기부자는 본인의 자발적 의사에 따라 기부를 진행하며, 기부 내용에 대한 사실성과 진정성을 보증합니다.
2. 수혜자는 기부금품의 사용 내역과 목적을 명확히 하며, 필요한 경우 기부자에게 정산 자료를 제공해야 합니다.
3. ‘회사’는 기부자와 수혜자 간 발생하는 분쟁, 손해, 세무 문제 등에 대해 법적 책임을 지지 않습니다.
제21조 기부 서비스 이용관련 준수 사항
1. 기부자는 플랫폼 내에 기재하는 기부 내용 및 기부 사실에 대해 허위 또는 과장 표시를 해서는 안됩니다.
2. 기부 내용이 허위로 판명될 경우 발생하는 모든 법적·행정적 책임은 기부자에게 있습니다
3. ‘회사’는 기부자 또는 수혜자가 약관의 의무를 위반하거나 허위 사실을 기재하는 등 서비스 운영에 지장을 초래하는 경우, 사전 통보 없이 해당 회원의 서비스 이용을 일시적 또는 영구적으로 제한할 수 있습니다.
제22조 기부자 및 수혜자 개인정보 보호
1. 기부자와 수혜자의 연결 과정에서 필요한 최소한의 개인정보(연락처, 이메일 등)는 상호 동의 하에 공유됩니다.
2. ‘회사’는 개인정보를 직접 수집·보관하지 않으며, 단순 전달·연결의 기능만 수행합니다.
제23조 기부 관련 면책 조항
1. ‘회사’는 기부의 성사 여부, 기부금품의 전달·사용, 기부에 따른 세무 처리 및 법적 분쟁에 대하여 책임을 지지 않습니다.
2. ‘회사’는 단순히 연결의 장을 제공할 뿐이며, 모든 기부 행위는 기부자와 수혜자 간의 독립적인 행위로 간주됩니다.
제24조 준거법 및 재판관할
1. ‘회사’와 ‘이용자’간 제기된 소송은 대한민국법을 준거법으로 합니다.
2. ‘회사’와 ‘이용자’간 발생한 분쟁에 대해 소송이 제기될 경우 ‘회사’의 본사 소재지를 관할하는 법원을 전속 관할법원으로 합니다.
부칙
서비스이용약관 ver. 1
1. 이 약관은 2026년 5월 20일부터 적용됩니다.
2. 회사는 약관을 변경하는 경우에 이용자가 그 변경 여부, 변경된 사항의 시행시기와 변경된 내용을 언제든지 쉽게 할 수 있도록 지속적으로 ‘서비스’를 통하여 공개합니다.`;
